var DESKTOP = 'desktop';
var MOBILE_PORTRAIT = 'mobile_portrait';
var MOBILE_LANDSCAPE = 'mobile_landscape';
module.exports = {
  DESKTOP: DESKTOP,
  MOBILE_PORTRAIT: MOBILE_PORTRAIT,
  MOBILE_LANDSCAPE: MOBILE_LANDSCAPE
};